/**
 * Shared polling cadence for "still analyzing" UI (intelligence extraction,
 * project analysis strip, live-updating recommendations). Keep every poller
 * on the same interval/timeout so behavior is predictable across surfaces.
 */
export const POLL_INTERVAL_MS = 5000;
export const POLL_TIMEOUT_MS = 3 * 60 * 1000;
